import {sortBy, uniqBy} from 'lodash';

import {SWEAnalysisResponse} from './api/analysis';
import {CsvRow} from './downloadData';

export function boxplotCsvRows(
  {bands, stats, currentValues}: SWEAnalysisResponse['elevationBandBoxplot'],
  volumeUnit: string,
  elevationUnit: string
): CsvRow[] {
  // The API's min/max are the whisker ends — the extremes within 1.5x IQR — so
  // the years beyond the fences only appear in the outliers column.
  return bands.map((band, i) => ({
    [`elevation band (${elevationUnit})`]: band,
    [`lower whisker (${volumeUnit})`]: stats[i].min,
    [`q25 (${volumeUnit})`]: stats[i].q25,
    [`median (${volumeUnit})`]: stats[i].median,
    [`q75 (${volumeUnit})`]: stats[i].q75,
    [`upper whisker (${volumeUnit})`]: stats[i].max,
    [`outliers (${volumeUnit})`]: stats[i].outliers.join('; '),
    [`current year (${volumeUnit})`]: currentValues[i] ?? null,
  }));
}

export function annualLinesCsvRows(
  {bands, years, current}: SWEAnalysisResponse['annualLines'],
  volumeUnit: string
): CsvRow[] {
  // The archived years already include the current year, so keep one row per year.
  return sortBy(uniqBy([current, ...years], 'year'), 'year').map(({year, values}) => ({
    year,
    ...Object.fromEntries(bands.map((band, i) => [`${band} (${volumeUnit})`, values[i] ?? null])),
  }));
}

export function elevationProfileCsvRows(
  {bandEdges, current, climatology}: SWEAnalysisResponse['elevationProfile'],
  volumeUnit: string,
  elevationUnit: string
): CsvRow[] {
  return current.map((v, i) => ({
    [`elevation band low (${elevationUnit})`]: bandEdges[i],
    [`elevation band high (${elevationUnit})`]: bandEdges[i + 1],
    [`current (${volumeUnit})`]: v ?? null,
    [`historical average (${volumeUnit})`]: climatology[i] ?? null,
  }));
}
